import React from 'react'
import { Link } from 'react-router-dom'

import ClickableCard from '../../layout/ClickableCard'
import MetadataLabel from '../MetadataLabel'
import * as  dateLib from '../../../../libraries/date'
import ContentTag from '../ContentTag'
import { useI18N } from '../../../../libraries/i18n/hook'
import CourseProgress from './CourseProgress'
import BookmarkButton from '../BookmarkButton'

type Props = {
  id: number
  title: string
  videosAmount: number
  documentsAmount: number
  totalWatchTime: number
  totalPlayTime?: number
  category: string
  image: string
  completed: boolean
  difficulty: string
  bookmarked?: boolean
}
const CourseCard: React.FC<Props> = ({ id, title, videosAmount, documentsAmount, completed, totalWatchTime, category, image, totalPlayTime, difficulty, bookmarked }) => {
  const { t } = useI18N()
  const renderCourseImage = () => {
    return <img src={image} alt={title} className='z-10 w-36 sm:w-full h-full sm:h-56 rounded-s-lg sm:rounded-b-none sm:rounded-t-lg object-cover' />
  }
  return (
    <ClickableCard>
      <div className='h-full'>
        <Link to={`/courses/${id}`} className='flex sm:block relative h-full'>
          <div className='absolute right-3 top-3 hidden lg:inline-block'>
            <ContentTag label={difficulty} bgColor='deep-green' />
          </div>
          <div className='relative block'>
            <div className='absolute top-2 z-40 left-[50%] -translate-x-[50%] inline-block lg:hidden'>
              <ContentTag label={difficulty} textColor='deep-green' bgColor='white' />
            </div>
            <div className='h-full block sm:hidden'>{renderCourseImage()}</div>
          </div>
          <div className='hidden sm:block'>{renderCourseImage()}</div>
          <div className='px-2.5 py-3  sm:p-3 w-full inline-block'>
            <div className='flex items-center justify-between'>
              <p className='h-12 sm:mb-3 line-clamp-2 text-black text-xs sm:text-sm font-semibold'>{title}</p>
              {bookmarked && <div className='ps-3 -translate-y-2'><BookmarkButton bookmarked onClick={() => {}} /></div>}
            </div>
            <div className='flex flex-col-reverse sm:flex-col gap-y-1 sm:gap-y-0'>
              <div className='text-2xs sm:text-xs inline-flex justify-between sm:justify-start items-center gap-x-4 text-gray'>
                <MetadataLabel icon='play'>
                  {videosAmount} {t('courses.class', { context: videosAmount > 1 ? 'plural' : '' })}
                </MetadataLabel>
                {documentsAmount > 0
                  && (
                    <div className='hidden lg:block'>
                      <MetadataLabel icon='document'>
                        <span>{documentsAmount} {t('courses.document', { context: documentsAmount > 1 ? 'plural' : '' })}</span>
                      </MetadataLabel>
                    </div>
                  )}
                  <div className='flex sm:hidden'>
                    <ContentTag label={category} bgColor='soft-green' textColor='deep-green' />
                  </div>
              </div>
              <div className='text-gray text-xs sm:mt-2'>
                <div className='text-2xs sm:text-xs flex justify-between sm:flex-col gap-y-4 mt-2 sm:gap-x-3'>
                  <div className='relative flex flex-1 flex-row gap-x-4 items-center'>
                    <div className='min-w-[75px] sm:min-w-[85px]'><MetadataLabel icon='clock'>{dateLib.parseSecondsToHoursAndMinutes(totalWatchTime)}</MetadataLabel></div>
                    <CourseProgress completed={completed} totalWatchTime={totalWatchTime} totalPlayTime={totalPlayTime} />
                  </div>
                  <div className='hidden sm:inline-flex'>
                    <ContentTag label={category} bgColor='soft-green' textColor='deep-green' />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Link>
      </div>
    </ClickableCard>
  )
}
export default CourseCard

